import RoutingStore from '../../stores/RoutingStore';
import UserStore from '../../stores/UserStore';
import GuestListStore from '../../stores/GuestListStore';
import UserActions from '../../actions/UserActions';
import PosStore from '../../stores/PosStore';

import Cookies from 'universal-cookie';
import Header from '../header/Header.react';
import Auth from '../auth/Auth.react';
import Main from '../main/Main.react';
import Notification from '../notification/Notification.react';
import Popup from '../popup/Popup.react';
import Delivery from '../popup/delivery/Delivery.react';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import PosActions from '../../actions/PosActions';
import VersionChecker from './VersionChecker.react';
import Reset from '../reset/Reset.react';
import AuthActions from '../../actions/AuthActions';
import Banner from '../banner/banner.react';
import UserApi from '../../api/UserApi';
import ConfigStore from '../../stores/ConfigStore';
class App extends React.Component {
    isSSOPage;
    constructor(props) {
        super(props);
        this.state = {
            user: UserStore.getState().user,
            route: [''],
            autoLoginPending: false,
        };
        this.onUserStoreChange = this.onUserStoreChange.bind(this);
        this.onRoutingStoreChange = this.onRoutingStoreChange.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.getToken = this.getToken.bind(this);

        var httpQuery = this.getHttpQuery();
        if (window.location.pathname.toLowerCase().startsWith('/curbside')) {
            window.location.href = window.location.href.toLowerCase() + '/index.html';
        }

        if(httpQuery['opt_out']) {
            window.localStorage.setItem('v1OptOut', '1');
        }

        const url = new URL(window.location.href);
        url.searchParams.delete('opt_out');
        window.history.replaceState(null, '', url.toString());

        if (httpQuery['samlLogin']) {
            const cookies = new Cookies();

            this.state.autoLoginPending = true;
            var c = cookies.get('LLSession', { path: '/' });
            AuthActions.autoLogin({ sessionId: c }).finally(() => {
                this.setState({ autoLoginPending: false });
            });
        } else if (httpQuery['dutchie_token']) {
            this.state.autoLoginPending = true;


            UserApi.consumeLoginToken({ token: httpQuery['dutchie_token'] })
                .then((result) => {
                    var data = result.Data;
                    return AuthActions.autoLogin({ sessionId: data.SessionId, skipRedirect: true })
                        .then((data) => {
                            const location = data.locations.find((x) => x.location_id == data.LocId);
                            if (location) {
                                return UserActions.selectLocation(location);
                            }
                        })
                        .then(() => {
                            const register = UserStore.getState().registers.find((x) => x.id == data.RegisterId);
                            if (register) {
                                UserActions.selectRegister(register);
                                GuestListStore.setPage('list');
                            }
                        });
                })
                .finally(() => {
                    this.setState({ autoLoginPending: false });
                    const url = new URL(window.location.href);
                    url.searchParams.delete('dutchie_token');
                    window.history.replaceState(null, '', url.toString());
                });
        }
    }

    getHttpQuery() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = decodeURIComponent(value);
        });
        return vars;
    }

    componentDidMount() {
        var self = this;
        this.getToken();
        PosActions.getBuildNumber();
        PosActions.getRegion();
        PosActions.getSSOLoginEnabled();
        UserStore.addChangeListener(this.onUserStoreChange);
        RoutingStore.addChangeListener(this.onRoutingStoreChange);
        PosStore.addChangeListener(this.onPosStoreChange);
        this.isSSOPage = window.location.href.toLowerCase().indexOf('ssologin') > -1;
        if (window.location.host.toLowerCase().indexOf('azurewebsites.net') > -1) {
            PosActions.getCurrentServer();
        }
    }

    componentWillUnmount() {
        this.getToken();
        UserStore.removeChangeListener(this.onUserStoreChange);
        RoutingStore.removeChangeListener(this.onRoutingStoreChange);
    }

    onUserStoreChange() {
        this.setState({ user: UserStore.getState().user });
    }

    onRoutingStoreChange() {
        this.setState({ route: RoutingStore.getRoute() });
    }

    onPosStoreChange() {
        const currentServer = PosStore.getState().currentServer;
        if (currentServer) {
            window.location.href = currentServer;
        }
    }

    getToken() {
        let search = new URLSearchParams(window.location.search);
        this.setState({
            token: search.get('token'),
        });
    }

    render() {
        const user = this.state.user;
        const route = this.state.route;
        const token = this.state.token;

        return (
            <div id='app' className='app'>
                {this.state.autoLoginPending && <div className='hide-overlay'></div>}
                <Banner />

                {route[0] !== 'cart-display' && <Header user={user} route={route} />}

                <div className='app__container'>
                    {!user && token && <Reset token={this.state.token} />}

                    {!user && !token && !this.isSSOPage && <Auth user={user} />}

                    {!user && !token && this.isSSOPage && <Auth user={user} isSSO={true} />}

                    {user && !token && <Main route={route} user={user} />}
                    <VersionChecker />
                </div>

                <Notification />
                <Popup />
                <Delivery />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./ui_src/app/components/app/App.react.jsx